import cx from 'classnames';
import { Moment } from 'moment';
import FullCalendar from '@tinper/rc-calendar/es/FullCalendar';
import { getTodayTime } from '@tinper/rc-calendar/es/util/';
import React, { ReactElement } from 'react';
import Checkbox from '../../wui-checkbox/src/index';
import Select from '../../wui-select/src/index';
import CalendarHourBody from './CalendarHourBody';
import CalendarWeekBody from './CalendarWeekBody';
import generate from './Generate';
import { formatMonth, getLunarContent, isSameDay, _disabledDate } from './util/utils';

const { generateM } = generate;
const CalendarFullBody: React.FC<any> = (props) => {
    const { clsPrefix, fieldid, mutiple, dateCellRender, fillSpace, localeStore: _locale, renderDateHeaderCell, timeEvents, showTimeLine, onTimeEventsClick, layout, headerRender, customInterval, showSingleMonth, isDragEvent,
        stateValue, stateCurrent, fillSpaceStyle, stateType, selectValuesMap, focusedDay, highLightDate, scrollDivRef, removeCellHighLight, calOrderScroll, calOnChange, calRenderDateHeaderCell, setSelectValuesMap, setFocusedDay, setHighLightDate, ...others } = props;
    const { moreRender, monthCellContentRender, monthFullCellRender, dateCellHeaderReader, dateCellContentRender, dateFullCellRender, disabledDate, allowLunar, disabledHoverStyle, weekStartsOn, onChange, quickSelect, onQuickSelect, getDateCellAttr, weekTimeEvents, onFCSelect } = props;
    // const {value: stateValue, fillSpaceStyle, type, selectValuesMap, focusedDay, highLightDate} = this.state;

    const onMutiChange = (value: Moment, flag: boolean) => {
        if (flag === undefined || flag === null) return;
        const values = new Map(selectValuesMap);
        if (flag) {
            values.set(value.format('YYYY-MM-DD'), flag);
        } else {
            values.delete(value.format('YYYY-MM-DD'));
        }
        // this.setState({ selectValuesMap: values })
        setSelectValuesMap(values)
        onChange && onChange(value, flag, [...values.keys()])
    }
    const getRowHightlightDates = (firstDay: Moment) => {
        const changeDatesFormat = []
        for (let i = 0; i < 7; i++) {
            const current = firstDay.clone().add(i, 'day');
            const isCurrentDisabled = _disabledDate(disabledDate)(current);
            if (!isCurrentDisabled) {
                changeDatesFormat.push(current.format('YYYY-MM-DD'));
            }

        }
        return changeDatesFormat
    }
    const selectRow = (firstDay: Moment) => {
        if (!quickSelect) return;
        const changeDatesFormat = getRowHightlightDates(firstDay);
        let flag = true;
        // 如果都是被选中 则 再次点击 清除
        if (changeDatesFormat.every(date => selectValuesMap.get(date) === true)) {
            flag = false;
        }
        onQuickSelect && onQuickSelect({ changeValues: changeDatesFormat, isChecked: flag, value: selectValuesMap, direction: 'horizontal' })

    }

    const setRowHighLight = (firstDay: Moment) => {
        if (!quickSelect) return;
        const changeDatesFormat = getRowHightlightDates(firstDay);
        // this.setState({ highLightDate: changeDatesFormat })
        setHighLightDate(changeDatesFormat)
    }

    const renderSelectRow = (_xindex: number, date: Moment) => {
        return quickSelect ? (
            <td onClick={() => selectRow(date.clone())}
                onMouseEnter={() => setRowHighLight(date.clone())}
                onMouseLeave={removeCellHighLight}
                style={{ width: '16px', border: 0 }}>
                <div
                    className={
                        cx({
                            [`${clsPrefix}-date`]: true,
                            [`${clsPrefix}-date-hover`]: disabledHoverStyle,
                            [`${clsPrefix}-row-select`]: quickSelect
                        })}><span>{_locale.langMap.clickSelect}</span></div>
            </td>
        ) : undefined;
    }

    const getFCDateCellAttr = (current: Moment, value: Moment) => {
        const customAttrs = getDateCellAttr?.(current, value) || {};
        if (highLightDate.some((date: any) => date === current.format('YYYY-MM-DD'))) {
            customAttrs.className = `${clsPrefix}-high-light` + (customAttrs.className ? ` ${customAttrs.className}` : '')
        }
        return customAttrs
    }

    const renderDefaultMonth = (current: Moment, _value: Moment) => {
        const headerChilds =
            [<span key={current.format('YYYY-MM-DD') + "_span"} className={`${clsPrefix}-cell-header-date ${clsPrefix}-cell-header-today`}>
                {mutiple && current.date() === 1 ? formatMonth(current.month(), _locale.langMap) : current.format('MMM')}
            </span>];
        let header = <div className={`${clsPrefix}-cell-header`}>{headerChilds}</div>
        const body = <div className={
            cx({
                [`${clsPrefix}-cell-body`]: true,
                [`${clsPrefix}-cell-body-drag`]: isDragEvent
            })
        }></div>
        let moreDom = moreRender ? moreRender(current) : null
        return (
            <div className={`${clsPrefix}-month-cell-box`}>
                {header}
                {body}
                {moreDom ? <div className={`${clsPrefix}-more-event`}>{moreDom}</div> : null}
            </div>
        )
    }

    const renderDefaultDate = (current: Moment, value: Moment) => {
        const selectValues = [...selectValuesMap.keys()].map(v => generateM()(v));
        const dateClass = `${clsPrefix}-date`;
        let today;
        let checked = false;
        let isFocusedDay = current.format('YYYY-MM-DD') == focusedDay;
        if (mutiple) {
            today = getTodayTime(selectValues[0] || value);
            checked = selectValues.some(v => isSameDay(v, current));
        } else {
            today = getTodayTime(value);
        }
        const isToday = isSameDay(current, today);
        let header;
        let isEdit = true;
        const isCurrentDisabled = _disabledDate(disabledDate)(current);
        const headerChilds =
            [mutiple ? <Checkbox className={`${clsPrefix}-cell-header-check`} disabled={isCurrentDisabled} key={current?.format('YYYY-MM-DD') + "_checkbox"}
                onClick={() => !isCurrentDisabled && onMutiChange(current, !checked)}
                checked={checked} fieldid={fieldid ? fieldid + '_input_' + current.format('YYYY_MM_DD') : undefined} /> : null,
            isToday ? (
                <span key={current.format('YYYY-MM-DD') + "_span"} className={`${clsPrefix}-cell-header-date ${clsPrefix}-cell-header-today`}>
                    {mutiple && current.date() === 1 ? formatMonth(current.month(), _locale.langMap) : current.date()}
                </span>
            ) : (
                <span key={current.format('YYYY-MM-DD') + "_span"} className={`${clsPrefix}-cell-header-date ${clsPrefix}-cell-header-solarday`}>
                    {mutiple && current.date() === 1 ? formatMonth(current.month(), _locale.langMap) : current.date()}
                </span>
            )
            ];
        if (allowLunar) {
            headerChilds.push(
                <span key={current.format('YYYY-MM-DD') + 'lunar-day'} className={`${clsPrefix}-cell-header-date ${clsPrefix}-cell-header-lunarday`}>
                    {
                        getLunarContent(current, mutiple)
                    }
                </span>
            )
        }
        if (dateCellHeaderReader) {
            const dateCellHeaderReaderArr = dateCellHeaderReader(current, selectValues, headerChilds);
            if (dateCellHeaderReaderArr[0].props.clsPrefix !== 'wui-checkbox') {
                isEdit = false;
            }
            header = <div className={`${clsPrefix}-cell-header`}>{dateCellHeaderReaderArr}</div>
        }

        let content: ReactElement | string | null = "";
        if (dateCellContentRender) {
            content = dateCellContentRender(current, selectValues);
        } else if (dateFullCellRender) {
            content = dateFullCellRender(current, selectValues);
        }
        let moreDom = moreRender ? moreRender(current) : null
        let dayNum = false
        if (weekStartsOn && weekStartsOn === 0 && (current.day() === 6 || current.day() === 5)) {
            dayNum = true
        } else if (weekStartsOn && weekStartsOn === 1 && (current.day() === 0 || current.day() === 6)) {
            dayNum = true
        } else if (!weekStartsOn && (current.day() === 6 || current.day() === 5)) {
            dayNum = true
        }
        const body = <div className={
            cx({
                [`${clsPrefix}-cell-body`]: true,
                [`${clsPrefix}-cell-body-drag`]: isDragEvent
            })
        }>{content}</div>
        return (
            <div onClick={() => {
                setFocusedDay(current.format('YYYY-MM-DD'))
                // this.setState({ focusedDay: current.format('YYYY-MM-DD') })
                if (!isEdit || isCurrentDisabled) return;
                onMutiChange(current, !checked)
            }}
            className={
                cx({
                    [dateClass]: true,
                    [`${clsPrefix}-date-hover`]: disabledHoverStyle,
                    [`${clsPrefix}-mutiple-selected-day`]: true,
                    [`${clsPrefix}-before-today`]: isCurrentDisabled,
                    [`${clsPrefix}-mutiple-selected-day-edit`]: checked && !isEdit,
                    [`${clsPrefix}-mutiple-focused-day`]: isFocusedDay && !isCurrentDisabled,
                })}>
                {header}
                {body}
                {moreDom ? <div className={
                    cx({
                        [`${clsPrefix}-more-event`]: true,
                        [`${clsPrefix}-more-event-right`]: dayNum,
                    })
                }>{moreDom}</div> : null}
            </div>
        )
    }

    let monthRender = stateType === 'month' && isDragEvent ? renderDefaultMonth : monthCellContentRender || monthFullCellRender;
    stateValue.locale(_locale.lang)
    const valueYear = stateValue.year();
    let value1 = stateValue
    if (!showSingleMonth) {
        value1 = generateM()(`${valueYear}-01-01`);
    }
    const cls = cx({
        [`${clsPrefix}-full-body`]: true,
        [`${clsPrefix}-display-sing-month`]: !!showSingleMonth
    });
    let dataRender = dateCellRender || renderDefaultDate;

    if (stateType === 'date') {
        return (
            <div className={cls}>
                <div ref={scrollDivRef}>
                    <FullCalendar
                        prefixCls={clsPrefix}
                        Select={Select}
                        fieldid={fieldid}
                        renderDateHeaderCell={calRenderDateHeaderCell}
                        renderSelectRow={renderSelectRow}
                        dateCellRender={dataRender}
                        disabledDate={() => false}
                        headerRender={() => null}
                        lang={_locale.lang}
                        getDateCellAttr={getFCDateCellAttr}
                        onTimeEventsClick={onTimeEventsClick}
                        showSingleMonth={!!showSingleMonth}
                        calendar={generate}
                        {...others}
                        onSelect={onFCSelect}
                        locale={_locale.langMap}
                        value={value1}
                        mutiple={mutiple}
                        weekStartsOn={weekStartsOn}
                        scrollAttrs={{ onScroll: calOrderScroll, style: fillSpaceStyle, className: fillSpace ? `${clsPrefix}-fill-space-init` : `` }}
                        onChange={calOnChange}
                    />
                </div>
            </div>
        )
    } else if (stateType === 'hour') {
        return (
            <CalendarHourBody
                clsPrefix={clsPrefix}
                fieldid={fieldid}
                value={stateValue}
                timeEvents={timeEvents}
                showTimeLine={showTimeLine}
                current={stateCurrent}
                onTimeEventsClick={onTimeEventsClick}
                layout={layout}
                customInterval={customInterval}
                onCreateEvent={props.onCreateEvent}
                silderModalBody={props.silderModalBody}
                silderModalHeader={props.silderModalHeader}
                onModalOk={props.onModalOk}
                isDragEvent={isDragEvent}
                locale={_locale.langMap}
                isEditEvent={props.isEditEvent}
                onHourBodyScroll={props.onHourBodyScroll}
                timezone={props.timezone}
                serverTimezone={props.serverTimezone}
                enableTimezone={props.enableTimezone}
                convertToServerTimezone={props.convertToServerTimezone}
            />
        )
    } else if (stateType === 'week') {
        return (
            <CalendarWeekBody
                clsPrefix={clsPrefix}
                fieldid={fieldid}
                value={stateValue}
                // timeEvents={timeEvents}
                weekTimeEvents={weekTimeEvents}
                showTimeLine={showTimeLine}
                current={stateCurrent}
                onTimeEventsClick={onTimeEventsClick}
                // layout={layout}
                customInterval={customInterval}
                onCreateEvent={props.onCreateEvent}
                silderModalBody={props.silderModalBody}
                silderModalHeader={props.silderModalHeader}
                onModalOk={props.onModalOk}
                isDragEvent={isDragEvent}
                weekStartsOn={weekStartsOn}
                locale={_locale.langMap}
                isEditEvent={props.isEditEvent}
                timezone={props.timezone}
                serverTimezone={props.serverTimezone}
                enableTimezone={props.enableTimezone}
                convertToServerTimezone={props.convertToServerTimezone}
            />
        )
    } else {
        return (
            <FullCalendar
                prefixCls={clsPrefix}
                Select={Select}
                fieldid={fieldid}
                headerRender={() => null}
                lang={_locale.lang}
                calendar={generate}
                {...others}
                locale={_locale.langMap}
                monthCellContentRender={monthRender}
                value={stateValue}
                type="month"
                weekStartsOn={weekStartsOn}
                onChange={calOnChange}
            />
        )
    }
}

export default CalendarFullBody;
